<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <br>
            <div class="row" style="margin: 10px;">
                <div class="col-sm-6">
                    <span><b>ชื่อ</b> : {{ driver.first_name }}</span>
                    <br/>
                    <span><b>นามสกุล</b> : {{ driver.last_name }}</span>
                    <br/>
                    <span>
                    <b>เบอร์โทรศัพท์</b> :
                    <span>{{ driver.phone }}</span>
                </span>
                </div>
                <div class="col-sm-6">
                    <span><b>ทะเบียนรถ</b> : {{ driver.license_plate }}</span>
                    <br/>
                    <span>
                        <b>ค่าผ่อนรถทั้งหมด</b> : {{ driver.car_fee_total ? driver.car_fee_total : 0 | currency }}
                    </span>
                    <br/>
                    <span>
                        <b>รวมค่าผ่อนรถที่ชำระแล้ว</b> : {{ driver.sum_car_fee ? driver.sum_car_fee : 0 | currency }}
                    </span>
                    <br/>
                    <span>
                        <b>คงค้างที่ต้องจ่าย</b> : {{ parseFloat(car_fee_total) - parseFloat(sum_car_fee) | currency }}
                    </span>
                </div>
            </div>
            <div class="col text-right" style="font-size: 20px;">
                <label style="color: royalblue"><b>รวมค่าผ่อนรถที่ชำระแล้ว</b> :
                    {{ driver.sum_car_fee ? driver.sum_car_fee : 0 | currency }} บาท</label>,
                <label style="color: darkgreen"><b>รวมค่าผ่อนหลังคาที่ชำระแล้ว</b> :
                    {{ driver.sum_car_roof ? driver.sum_car_roof : 0 | currency }} บาท</label>
            </div>
            <div class="col-12 table-responsive">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">วัน/เดือน/ปี ที่จ่าย</th>
                        <th scope="col">TN</th>
                        <th scope="col">ค่าผ่อนรถที่จ่ายมาแล้ว</th>
                        <th scope="col">ค่าผ่อนหลังคาที่จ่ายมาแล้ว</th>
                        <th scope="col">หมายเหตุ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in driver_details_table">
                        <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                        <td class="text-left">
                            <template v-if="data.driver_details_invoices">
                               <span v-for="(tn,i) in data.driver_details_invoices">
                                    <span v-if="i > 0"><br/></span>
                                    <span>{{ tn.invoice.invoice_id }}</span>
                                    <span
                                        v-if="tn.invoice.customer&&!tn.invoice.customer_other&&tn.invoice.customer.store_name">
                                        {{ tn.invoice.customer && tn.invoice.customer.store_name ? tn.invoice.customer.store_name : tn.invoice.customer.name }}
                                    </span>
                                    <span
                                        v-else-if="tn.invoice.customer&&tn.invoice.customer_other&&tn.invoice.customer_other.store_name">
                                        {{ tn.invoice.customer && tn.invoice.customer.store_name ? tn.invoice.customer.store_name : tn.invoice.customer.name }}
                                    </span>
                                </span>
                            </template>
                            <template v-else-if="typeof data.user_id !== 'undefined'">
                                ผู้บันทึก: {{ data.user_id }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <td>
                            <template v-if="data.car_fee">
                                {{ data.car_fee }}
                            </template>
                        </td>
                        <td>
                            <template v-if="typeof data.car_roof !== 'undefined'">
                                {{ data.car_roof | currency }}
                            </template>
                            <template v-else>
                                {{ data.amount | currency }}
                            </template>
                        </td>
                        <td>
                            <template v-if="typeof data.reason !== 'undefined'">
                                {{ data.reason }}
                            </template>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="col text-left" style="font-size: 16px; color: #006df0">**เมื่อมีการลบในรายการค่าเที่ยว
                    ค่าผ่อนรถจะถูกลบไปด้วย
                </div>
                <br/>
                <div>
                    <vue-pagination :pagination="dataPaginate"
                                    @paginate="getPage">
                    </vue-pagination>
                </div>
            </div>
            <b-modal hide-header hide-footer
                     ref="delete_data">
                <div style="text-align: center;">
                    <delete-confirm-modal @submit="deleteData">
                    </delete-confirm-modal>
                </div>
            </b-modal>
            <b-modal hide-footer hide-header no-close-on-backdrop no-close-on-esc ref="loading">
                <loading :msg="msg" :status="status"></loading>
            </b-modal>
            <!--<pre class="alert alert-primary">{{ driver }}</pre>-->
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
import VuePagination from "../../Pagination";
import Loading from "@/components/Utility/Loading.vue";

export default {
    components: {
        Loading,
        VuePagination,
        DeleteConfirmModal
    },
    name: "car-fee-information",
    data() {
        return {
            car_fee_total: 0,
            sum_car_fee: 0,
            sum_car_roof: 0,
            delete_id: null,
            msg: '',
            status: '',
            items: [
                {
                    text: "บันทึกค่าผ่อนรถ",
                    to: {name: "car-fee-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
        }
    },
    created() {

    },
    computed: {
        ...mapState({
            driver: state => {
                return state.Driver.form;
            },
            driver_details_table: state => {
                return state.DriverDetails.driver_details_table
            },
            dataPaginate: state => {
                return state.DriverDetails.dataPaginate
            },
        }),
    },
    methods: {
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_data.show();
        },
        hideDeleteModal() {
            this.$refs.delete_data.hide();
        },
        deleteData(value) {
            this.hideDeleteModal();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getPage() {
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
            this.status = 1;
            this.showLoadingModal();
            let data = {
                driver_id: this.driver.id,
                page: this.dataPaginate.current_page,
            }
            this.$store.dispatch("DriverDetails/getCarFeeDriver", data).then(()=>this.hideLoadingModal())
        }
    }
}
</script>

<style scoped>
thead {
    background-color: lightgray;
    color: black;
}

tbody {
    background-color: white;
    color: black;
}
</style>
